import React from 'react';
import { connect } from 'react-redux';
import Header from '../elements/Header';
import { Link } from 'react-router-dom';
import { __ } from 'i18n-for-browser';

import ListButton from '../elements/ListButton';
import {
  getUnreadWinstGlobas,
  getUnreadVerliesGlobas
} from '../../helpers/feedbackHelpers';

import Team from '../../assets/img/icons/economy/team.svg';
import Economy from '../../assets/img/icons/economy/economy.svg';
import UpGlobas from '../../assets/img/icons/economy/up-globas.svg';
import MinGlobas from '../../assets/img/icons/economy/min-globas.svg';
import PopupTitle from "../elements/PopupTitle";

class EconomyOverview extends React.Component {
  render() {
    const { gameState, feedback, group } = this.props;
    const {prevRoundSum} = gameState;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];
    const {prevRoundFeedbackData } = feedback;
    if(!prevRoundSum) return null;
    const {OneTimeEffect} = prevRoundSum;
    const unreadWinstGlobas = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    const unreadVerliesGlobas = getUnreadVerliesGlobas(prevRoundFeedbackData).length;

    const isStartSituation = (group.Rounds.length === 2);

    return (
      <div>
        <Header history={this.props.history} historic={false} buttonType="cross" viewType='list' showTitle={false} />
        <div className='container ministries-list'>
          <div className='economy-list'>
            <PopupTitle popupId={`m${gameState.difficulty === 'PRO' ? 'h' : 'l'}gvteconomie`} tag={'h3'}/>
            <Link to={{
              pathname: "/economy/total"}}>
              <ListButton bgColor='darkblue' title={__("sim_totalglobas")} icon={Economy} globas={gameState.totalEconomy} points={currentRoundGameState.earnedPoints}/>
            </Link>

            <Link to={{
              pathname: "/economy/earned"}}>
              <ListButton bgColor='blue' title={__("sim_earnedglobas")} icon={Team} globas={currentRoundGameState.earnedGlobas} points={currentRoundGameState.earnedPoints}/>
            </Link>

            <Link to={{
              pathname: "/ministries/overview/profit"}}>
              <ListButton bgColor='blue' title={__('sim_winstglobas')} icon={UpGlobas} feedbackCount={unreadWinstGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.WG === 0 ? 0 : '+ ' + OneTimeEffect.WG)}/>
            </Link>
            <Link to={{
              pathname: "/ministries/overview/loss"}}>
              <ListButton bgColor='blue' title={__('sim_verliesglobas')} icon={MinGlobas} feedbackCount={unreadVerliesGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.VG === 0 ? 0 : '- ' + Math.abs(OneTimeEffect.VG))}/>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  gameState: state.gameState,
  feedback: state.feedback,
  group: state.group,
}))(EconomyOverview);



// WEBPACK FOOTER //
// ./src/components/routes/EconomyOverview.js